import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <main class="route-bridge">
      <div class="route-bridge__label">403 Forbidden</div>
      <h1>Access denied</h1>
      <p>This page is not available for your role or current product access.</p>
      <div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;">
        <a class="primary-button" [routerLink]="workspaceLink()" *ngIf="isAuthenticated()">Go to my workspace</a>
        <a class="secondary-button" routerLink="/login" *ngIf="!isAuthenticated()">Go to login</a>
      </div>
    </main>
  `
})
export class ForbiddenComponent {
  private readonly authService = inject(AuthService);

  readonly isAuthenticated = computed(() => this.authService.isAuthenticated());
  readonly workspaceLink = computed(() => this.authService.getDefaultAppRoute());
}
